<div class="footer-container new-footer">
    <ng-container [ngSwitch]="partnerName">
        <ng-container *ngSwitchCase="PartnerNamesEnum.AVEXTRA">

        </ng-container>
        <ng-container *ngSwitchDefault>
            <svg class="footer-divider" fill="#ffffff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 10" preserveAspectRatio="none">
                <polygon points="100 0 100 10 0 10"></polygon>
            </svg>
        </ng-container>
    </ng-container>
    
    <footer>
        <div class="container-xl">
            <div class="footer">
                <div class="logo" *ngIf="!isPartnerPage">
                    <a href="/">
                        <img src="/Copeia.svg" alt="Copeia" />
                    </a>
                </div>
                <div class="footer-links">
                    <div class="copeia-life">Powered by Copeia.de</div>
                    <div class="links">
                        <ul>
                            <ng-container *ngIf="!isPartnerPage">
                                <li>
                                    <a href="/">Cannabischargen Informationen</a>
                                </li>
                                <li>
                                    <a href="/cannabisantrag">Medizinalcannabis Antrag</a>
                                </li>
                            </ng-container>
                            <li>
                                <a href="https://www.copeia.info/">Über Copeia</a>
                            </li>
                            <li>
                                <a href="/impressum">Impressum</a>
                            </li>
                            <li>
                                <a *ngIf="!isPartnerPage" href="/datenschutz">Datenschutz</a>
                                <a *ngIf="isPartnerPage" href="/private/{{partnerName}}/datenschutz">Datenschutz</a>
                            </li>
                            <li>
                                <a href="mailto:info@copeia.de">Kontakt</a>
                            </li>
                        </ul>
                    </div>
                    <div class="copeia-last">© Copeia, {{fullYear}}</div>
                </div>
            </div>
        </div>
    </footer>
</div>
